export function moveToAnchor(anchor: string) {
  const anchorElement = document.querySelector(anchor) as HTMLElement
  const isMobile = window.innerWidth < 1025
  const headerHeightConfig = {
    desktop: {scrollUp: 128, scrollDown: 80},
    mobile: {scrollUp: 132, scrollDown: 80}
  }

  if (anchorElement) {
    const y = anchorElement.getBoundingClientRect().top
    let indent: number

    if (y > 0) {
      isMobile ? indent = headerHeightConfig.mobile.scrollDown : indent = headerHeightConfig.desktop.scrollDown
    } else {
      isMobile ? indent = headerHeightConfig.mobile.scrollUp : indent = headerHeightConfig.desktop.scrollUp
    }

    window.scrollBy({
      top: y - indent
    })
  }
}
